var nonExternal = [
	"facebook.com/allsouth",
	"instagram.com/allsouthfcu",
	"linkedin.com/company/allsouth",
	"www.youtube.com/channel/UCI4Ssfs_8IWeGX4RTTZzoeQ",
	"twitter.com/AllSouthFCU",
	"powerforms.docusign.net/b6f8bd4d-4eda-4475-b33b-4f887b2ca3ba?accountId=ab1ff462-f1c1-4baf-9cb0-3471d757406f&env=na2",
	"www.myaccountbenefits.com",
	"www.myaccountbenefits.com/cu-visa?lc=9382",
	"www.trustage.com/property-insurance/home?orgIdentifier=000000012616&marketingCampaignCode=ICTLF072&utm_source=AllSouth%20Federal%20Credit%20Union&utm_medium=CULK_Copy&utm_campaign=ICTLF072&utm_content=CM000647",
	"www.trustage.com/auto-insurance?orgIdentifier=000000012616&marketingCampaignCode=ICTMC24B&utm_source=AllSouth%20Federal%20Credit%20Union&utm_medium=CULK_Copy&utm_campaign=ICTMC24B&utm_content=CM000143",
	"www.trustage.com/life-insurance/quote?pr=0&orgIdentifier=000000012616&marketingCampaignCode=CCTL000003&utm_source=AllSouth%20Federal%20Credit%20Union&utm_medium=CULK_Copy&utm_campaign=CCTL000003&utm_content=CM000655",
	"www.trustage.com/add-insurance?orgIdentifier=000000012616&marketingCampaignCode=CBGL000026&utm_source=AllSouth%20Federal%20Credit%20Union&utm_medium=CULK_Copy&utm_campaign=CBGL000026&utm_content=CM000659",
	"www.myaccountaccess.com/onlineCard/login.do?theme=elan1&loc=9382",
	"www.deluxe.com/business-operations/hr/payroll/employer-portal/allsouth/",
	"fitech.com/membersolutions/allsouthfcu/",
	"na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=b6f8bd4d-4eda-4475-b33b-4f887b2ca3ba",
	"na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=dac8dcd5-37ab-4dd6-b0b7-a8eb16e3e8d1",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=9G315585H5&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=M8981XWPD9&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=942HQMH384&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=994D7QV97X&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=MXV789X2BH&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=X82G7P6BQ4&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=8HVG29R2QB&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=947931B833&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=619VQQ32G3&preparerType=customer",
	"online1.elancard.com/oad/learnMoreCorrespondent.controller?locationCode=9382&offerId=GGDV8PW9WX&preparerType=customer",
	"trustage.liveplatform.com/CreditUnions/AllSouthFederalCreditUnion/Orders/Order2023-07-27134545/MintedAssets/AUT-29483763HomeProductWebCopy/track.mhtml",
	"trustage.liveplatform.com/CreditUnions/AllSouthFederalCreditUnion/Orders/Order2023-07-27134545/MintedAssets/AUT-29489583AutoProductWebCopy/track.mhtml",
	"trustage.liveplatform.com/CreditUnions/AllSouthFederalCreditUnion/Orders/Order2023-07-27134545/MintedAssets/WHL-29471853ProductWebCopy/track.mhtml",
	"trustage.liveplatform.com/CreditUnions/AllSouthFederalCreditUnion/Orders/Order2023-07-27134545/MintedAssets/GEN-29440193EmotionProductCombination/track.mhtml",
	"trustage.liveplatform.com/CreditUnions/AllSouthFederalCreditUnion/Orders/Order2023-07-27134545/MintedAssets/ADI-34698522ADDCHSRiderWeb/track.mhtml",
	"co-opcreditunions.org/locator/?ref=co-opatm.org&sc=1&utm_source=co-opfs.org&utm_medium=cta&utm_campaign=b2bsite&utm_term=locatorpage",
	"co-opcreditunions.org/locator/?ref%3Dco-opatm.org%26sc%3D1%26utm_source%3Dco-opfs.org%26utm_medium%3Dcta%26utm_campaign%3Db2bsite%26utm_term%3Dlocatorpage&sa=D&source=editors&ust=1655919199094166&usg=AOvVaw1dTbxRofY0YmEnK2gIJuvM",
	"info.allsouth.org/connectwithkate",
	"info.allsouth.org/connectwithangela",
	"info.allsouth.org/connectwithtyler",
	"info.allsouth.org/connectwithmelissa",
	"info.allsouth.org/connectwithkenny",
];
var templateUrl = object_name.templateUrl;

if (typeof jQuery != 'undefined') {
	if (!window.location.origin){
		window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
	}
	jQuery(document).ready(function($) {
		var filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
 		jQuery(document).on('click', 'body a, [data-event-category]', function(event) {
			var el = jQuery(this);
			var track = true;
			var href = (typeof(el.attr('href')) != 'undefined' ) ? el.attr('href') : '';
			var isThisDomain = (href.indexOf(window.location.origin) == 0 || !href.match(/^https?\:\/\//i));
			var externalModalLink = (el.parents('#external_modal').length > 0 ? true : false);
			if (!href.match(/^javascript:/i)) {
				var nonInteraction = false;
				var evt = {
					hitType: 'event',
				};
				if ('sendBeacon' in navigator){
					evt.transport = 'beacon';
				}
				if (href.match(/^mailto\:/i)) {
					evt.category = 'email';
					evt.action = 'click';
					evt.label = href.replace(/^mailto\:/i, '');
				}
				else if (href.match(filetypes)) {
					var extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
					evt.category = 'download';
					evt.action = 'click-'+extension[0].toLowerCase();
					evt.label = href;
				}
				else if (href.match(/^https?\:/i) && !isThisDomain) {
					evt.category = 'outbound';
					evt.action = 'click';
					evt.label = href.replace(/^https?\:\/\//i, '');
					evt.nonInteraction = true;
				}
				else if (href.match(/^tel\:/i)) {
					evt.category = 'telephone';
					evt.action = 'click';
					evt.label = href.replace(/^tel\:/i, '');
				}
				else if (el.data('event-category')){
					evt.category = el.data('event-category');
					evt.action = el.data('event-action')||'click';
					evt.label = el.data('event-label')||href;
					if (el.data('event-value'))evt.value = el.data('event-value');
				}
				else track = false;

				var noModal;
				var path = window.location.pathname;
				noModal = href.match(/mortgage.allsouth.org|estatements.allsouth.org|online1.elancard.com|allsouth.cashplease.org|securemail.allsouth.org|orderpoint.deluxe.com|allsouth.onlinebank.com|forms.fivision.com|blog.allsouth.org|paybill.com|creditcardlearnmore.com|secure.allsouth.org|trustage.com|info.allsouth.org|info.allsouth.com/g);

				var hostname = href.match(/https?:\/\/(.*)/);
				if (hostname) hostname = hostname[1];
				if (nonExternal.indexOf(hostname) >= 0) noModal = true;

				var gCat = el.data('event-category');
				var gAction = el.data('event-action');
				var gLabel = el.data('event-label');


				if ($(this).hasClass(".button-text")) {
					var link = $(this).attr('href');
					var productID = $(this).attr('data-product');
					var product = products.filter(function(prod) {
						return prod.id === productID;
					})[0];
					window.dataLayer = window.dataLayer || [];
					var event = {};
					event.event = 'Apply Now / Enroll Click';
					event.productName = product.header;
					event.productID = product.id;
					event.link = link;
					event.source = location.pathname;
					window.dataLayer.push(event);
					if(product.applyEnrollPixel) {
						$('body').prepend(product.applyEnrollPixel);
					}
				}

				if (track) {
					if (evt.category == 'outbound' && !externalModalLink && !noModal){
						event.preventDefault();
						event.stopPropagation();
				        var html = '<div id="modal-logo"><img src="'+templateUrl+'/assets/images/allsouthfcu-logo.svg"></div><br>';
						html += '<p>You are leaving the AllSouth Federal Credit Union website. AllSouth Federal Credit Union has no responsibility for any external website. It neither endorses the information, content, presentation, or accuracy nor makes any warranty, express or implied, regarding any external site. Thank you for visiting AllSouth Federal Credit Union.</p>';
				        html += '<p style="text-align:center;"><a href="'+href+'" style="margin-right:15px;" class="button close-modal" target="_blank">Okay</a><a type="button" data-close aria-label="Close modal" class="button close-modal">Cancel</a></p>';
						$('#external_modal').html(html);
						$('#external_modal').foundation('open');

						$('.close-modal').on('click', function() {
							$('#external_modal').foundation('close');
						});

						// if(gCat && gAction && gLabel) {
						// 	ga('send', 'event', gCat, gAction, gLabel, ('sendBeacon' in navigator ? {transport: 'beacon'} : null));
						// }
					}
					else {
						if ((evt.category == 'outbound' || evt.category == 'download') && (el.attr('target') == undefined || el.attr('target').toLowerCase() != '_blank') && (!('sendBeacon' in navigator))) {
							evt.hitCallback = function(){
								window.location.href = href;
							};
						};
						// ga('send', 'event', gCat, gAction, gLabel, ('sendBeacon' in navigator ? {transport: 'beacon'} : null));
					}
				}
			}
		});
	});
} else {
	alert('outbound.js requires jQuery.');
}
